import { pick } from 'lodash-es';
import type { Types } from '../types';
import type { BaseOptions } from '../../common/types';
import type { OutTypes } from './schedules';

export default (
  division: Types.Mixed.Division,
  options:  BaseOptions
): Pick<OutTypes.division, 'displayName' | 'start' | 'end'> => {
  return pick(division, 'displayName', 'start', 'end');
};
